import platform from "../../../util/platform";
const create = (moduleTemplate) => {
    return (params) => {
        const path = `/content/module-templates/create`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, moduleTemplate);
    };
};
const update = (moduleTemplate) => {
    return (params) => {
        const path = `/content/module-templates/update`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, moduleTemplate);
    };
};
const deleteTemplate = (moduleTemplateId) => {
    return (params) => {
        const path = `/content/module-templates/id/${moduleTemplateId}/delete`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, {});
    };
};
const getForVendorById = (moduleTemplateId) => {
    return (params) => {
        const path = `/content/module-templates/id/${moduleTemplateId}`;
        return platform.get(params, platform.getEdgeBaseUrl(), path);
    };
};
const getAllForVendor = () => {
    return (params) => {
        const path = `/content/module-templates`;
        return platform.get(params, platform.getEdgeBaseUrl(), path);
    };
};
const getAllPreviewsForVendor = () => {
    return (params) => {
        const path = `/content/module-templates/previews`;
        return platform.get(params, platform.getEdgeBaseUrl(), path);
    };
};
const moduleTemplates = {
    create,
    update,
    deleteTemplate,
    getForVendorById,
    getAllForVendor,
    getAllPreviewsForVendor,
};
export default moduleTemplates;
